import Markdoc from "@markdoc/markdoc";
import type { LoaderArgs } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { Container, Stack } from "@chakra-ui/react";

export async function loader({ request }: LoaderArgs) {
  const requestOrigin = new URL(request.url).origin;
  const markdown = await fetch(
    `${requestOrigin}/policies/20210812-privacy-policy.md`,
  ).then(res => res.text());
  return json({ markdown });
}

export default function PrivacyPolicy() {
  const { markdown } = useLoaderData<typeof loader>();
  const markdownAst = Markdoc.parse(markdown);
  const content = Markdoc.transform(markdownAst, {});
  const html = Markdoc.renderers.html(content);

  return (
    <Container as={Stack} p={10} spacing={8} maxW={"4xl"} border={"none"}>
      <div className={"markdown"} dangerouslySetInnerHTML={{ __html: html }} />
    </Container>
  );
}
